import { Zap, Users, DollarSign, ArrowRight } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export function FeaturesBar() {
    return (
        <section className="relative py-12 md:py-16 overflow-hidden">
            {/* Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary via-purple-600 to-primary opacity-90" />

            {/* Animated Glow Effects */}
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-400/30 rounded-full blur-3xl animate-pulse-subtle" />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-400/30 rounded-full blur-3xl animate-pulse-subtle delay-1000" />

            <div className="container relative mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {/* Feature 1 - Speed */}
                    <div className="group relative">
                        <Link href="/dashboard">
                            <div className="backdrop-blur-xl bg-white/10 rounded-2xl p-6 border border-white/20 shadow-2xl transition-all duration-500 hover:scale-105 hover:bg-white/15 hover:shadow-primary/50 cursor-pointer">
                                <div className="flex flex-col items-center text-center gap-4">
                                    {/* Icon Container */}
                                    <div className="relative">
                                        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-lg group-hover:shadow-yellow-500/50 transition-all duration-500 group-hover:rotate-6 group-hover:scale-110">
                                            <Zap className="h-8 w-8 text-white" />
                                        </div>
                                        {/* Glow effect */}
                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-500" />
                                    </div>

                                    {/* Text Content */}
                                    <div>
                                        <h2 className="font-bold text-xl mb-2 text-white">AI Edits in 30 Seconds</h2>
                                        <p className="text-white/80 text-sm leading-relaxed">Seriously. That fast.</p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>

                    {/* Feature 2 - Human Help */}
                    <div className="group relative">
                        <Link href="/dashboard">
                            <div className="backdrop-blur-xl bg-white/10 rounded-2xl p-6 border border-white/20 shadow-2xl transition-all duration-500 hover:scale-105 hover:bg-white/15 hover:shadow-primary/50 cursor-pointer">
                                <div className="flex flex-col items-center text-center gap-4">
                                    {/* Icon Container */}
                                    <div className="relative">
                                        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center shadow-lg group-hover:shadow-purple-500/50 transition-all duration-500 group-hover:rotate-6 group-hover:scale-110">
                                            <Users className="h-8 w-8 text-white" />
                                        </div>
                                        {/* Glow effect */}
                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-purple-400 to-pink-500 blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-500" />
                                    </div>

                                    {/* Text Content */}
                                    <div>
                                        <h2 className="font-bold text-xl mb-2 text-white">Not Happy? Get Human Help</h2>
                                        <p className="text-white/80 text-sm leading-relaxed">Pass to pro editors anytime</p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>

                    {/* Feature 3 - Fair Pricing */}
                    <div className="group relative">
                        <Link href="/pricing">
                            <div className="backdrop-blur-xl bg-white/10 rounded-2xl p-6 border border-white/20 shadow-2xl transition-all duration-500 hover:scale-105 hover:bg-white/15 hover:shadow-primary/50 cursor-pointer">
                                <div className="flex flex-col items-center text-center gap-4">
                                    {/* Icon Container */}
                                    <div className="relative">
                                        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-lg group-hover:shadow-green-500/50 transition-all duration-500 group-hover:rotate-6 group-hover:scale-110">
                                            <DollarSign className="h-8 w-8 text-white" />
                                        </div>
                                        {/* Glow effect */}
                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-green-400 to-emerald-500 blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-500" />
                                    </div>

                                    {/* Text Content */}
                                    <div>
                                        <h2 className="font-bold text-xl mb-2 text-white">Pay Per Download</h2>
                                        <p className="text-white/80 text-sm leading-relaxed">No monthly fees. Free previews.</p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
